export const ANONYMOUSLY_FREE_TIME_FOR_MONTH_QUERY_KEY = 'anonymouslyFreeTimeForMonthQueryKey'
export const FREE_TIME_FOR_MONTH_QUERY_KEY = 'freeTimeForMonthQueryKey'
export const ANONYMOUSLY_NEAREST_FREE_TIME_QUERY_KEY = 'anonymouslyNearestFreeTimeQueryKey'
export const NEAREST_FREE_TIME_QUERY_KEY = 'nearestFreeTimeQueryKey'
